import { type StoreActionApi } from 'react-sweet-state';

import type { ResearchStepDocument } from './MessageResearch';
import type { ChatMessageResearchStore } from './types';
import { updateStep } from './updateStep';

type AppendStepDocumentArgs = {
	messageId: string;
	stepId: string;
	document: ResearchStepDocument;
};

type ChatMessageResearchStoreAction = (api: StoreActionApi<ChatMessageResearchStore>) => void;

export const appendStepDocument: (args: AppendStepDocumentArgs) => ChatMessageResearchStoreAction =
	({ messageId, stepId, document }) =>
	({ dispatch }: StoreActionApi<ChatMessageResearchStore>) => {
		dispatch(
			updateStep({
				messageId,
				stepId,
				updater: (step) => ({
					...step,
					documents: [...(step.documents ?? []), document],
				}),
			}),
		);
	};
